(() => {
  const SELECTOR = 'details-modal.deeb-header-search';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new WeakMap();

  class DeebSearchMotion {
    constructor(root) {
      this.root = root;
      this.details = root.querySelector('details');
      this.closeButton = root.querySelector('.deeb-search-modal__close');
      this.closeTimer = 0;
      this.closing = false;
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.init();
    }

    init() {
      if (!this.details) return;
      this.details.addEventListener('keyup', this.onKeyUp, true);
      this.details.addEventListener('toggle', this.onToggle);
      this.closeButton?.addEventListener('click', this.onCloseClick, true);
    }

    onKeyUp(event) {
      if (!this.details.open || event.key !== 'Escape') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.requestClose();
    }

    onCloseClick(event) {
      if (!this.details.open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.requestClose();
    }

    onToggle() {
      if (!this.details.open) {
        this.root.classList.remove('is-closing');
        this.closing = false;
        if (this.closeTimer) window.clearTimeout(this.closeTimer);
        this.closeTimer = 0;
      }
    }

    requestClose() {
      if (this.closing) return;

      if (reducedMotion.matches || typeof this.root.close !== 'function') {
        this.root.close?.(true);
        return;
      }

      this.closing = true;
      this.root.classList.add('is-closing');

      this.closeTimer = window.setTimeout(() => {
        this.root.close(true);
        this.root.classList.remove('is-closing');
        this.closing = false;
        this.closeTimer = 0;
      }, 360);
    }

    destroy() {
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      this.details?.removeEventListener('keyup', this.onKeyUp, true);
      this.details?.removeEventListener('toggle', this.onToggle);
      this.closeButton?.removeEventListener('click', this.onCloseClick, true);
      controllers.delete(this.root);
    }
  }

  const init = (scope = document) => {
    const roots = scope.matches?.(SELECTOR)
      ? [scope]
      : [...(scope.querySelectorAll?.(SELECTOR) || [])];

    roots.forEach((root) => {
      if (controllers.has(root)) return;
      controllers.set(root, new DeebSearchMotion(root));
    });
  };

  init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);
    controllers.get(root)?.destroy();
  });
})();
